export function reverseDate(date: Date) {
  return date.toLocaleDateString('en-GB').split('/').reverse().join('-');
}
